var $7b53f774eb112f85$exports = {};
const $7b53f774eb112f85$var$CARD = {
    R: 18,
    GAP: 16
};
let $7b53f774eb112f85$var$vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
let $7b53f774eb112f85$var$vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
function $7b53f774eb112f85$var$buildRectPath(W, H, R) {
    return [
        `M ${R} 0`,
        `L ${W - R} 0`,
        `A ${R} ${R} 0 0 1 ${W} ${R}`,
        `L ${W} ${H - R}`,
        `A ${R} ${R} 0 0 1 ${W - R} ${H}`,
        `L ${R} ${H}`,
        `A ${R} ${R} 0 0 1 0 ${H - R}`,
        `L 0 ${R}`,
        `A ${R} ${R} 0 0 1 ${R} 0 Z`
    ].join(' ');
}
function $7b53f774eb112f85$var$getCardConfig(W) {
    if (W < 640) return {
        R: 10,
        GAP: 0,
        mapWidthRatio: 0.95,
        mapHeightRatio: 0.25,
        notch: false
    };
    if (W < 900) return {
        R: 18,
        GAP: 16,
        mapWidthRatio: 0.5,
        mapHeightRatio: 0.5,
        notch: true
    };
    return {
        R: 18,
        GAP: 16,
        mapWidthRatio: 0.5,
        mapHeightRatio: 0.5,
        notch: true
    };
}
function $7b53f774eb112f85$var$buildPath(W, H, CARD) {
    const cfg = $7b53f774eb112f85$var$getCardConfig(W);
    const MAP_W = W * cfg.mapWidthRatio - cfg.GAP;
    const MAP_H = H * cfg.mapHeightRatio - cfg.GAP;
    const MAP_LEFT = W - MAP_W;
    if (!cfg.notch) // Mobile: simple rounded rect, no notch geometry needed
    return {
        d: $7b53f774eb112f85$var$buildRectPath(W, H, cfg.R),
        MAP_W: MAP_W,
        MAP_H: MAP_H,
        MAP_LEFT: MAP_LEFT
    };
    const NOTCH_X = MAP_LEFT - cfg.GAP;
    const NOTCH_Y = MAP_H + cfg.GAP;
    const d = [
        `M ${cfg.R} 0`,
        `L ${NOTCH_X - cfg.R} 0`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${NOTCH_X} ${cfg.R}`,
        `L ${NOTCH_X} ${NOTCH_Y - cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 0 ${NOTCH_X + cfg.R} ${NOTCH_Y}`,
        `L ${W - cfg.R} ${NOTCH_Y}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${W} ${NOTCH_Y + cfg.R}`,
        `L ${W} ${H - cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${W - cfg.R} ${H}`,
        `L ${cfg.R} ${H}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 0 ${H - cfg.R}`,
        `L 0 ${cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${cfg.R} 0 Z`
    ].join(' ');
    return {
        d: d,
        MAP_W: MAP_W,
        MAP_H: MAP_H,
        MAP_LEFT: MAP_LEFT
    };
}
const $7b53f774eb112f85$var$mapCard = document.querySelector('.map-card');
const $7b53f774eb112f85$var$cardContent = document.querySelector('.card-content');
const $7b53f774eb112f85$var$cardRoot = document.querySelector('.card-root');
const $7b53f774eb112f85$var$viewbox = document.querySelector('.viewbox');
let $7b53f774eb112f85$var$prevIsMobile = null;
function $7b53f774eb112f85$var$reparentMapCard(isMobile) {
    if (isMobile === $7b53f774eb112f85$var$prevIsMobile) return;
    $7b53f774eb112f85$var$prevIsMobile = isMobile;
    if (isMobile) {
        $7b53f774eb112f85$var$mapCard.style.position = 'static';
        $7b53f774eb112f85$var$mapCard.style.alignSelf = 'center';
        $7b53f774eb112f85$var$mapCard.style.background = "none";
        $7b53f774eb112f85$var$mapCard.style.boxShadow = "none";
        $7b53f774eb112f85$var$cardContent.style.width = '100%';
        $7b53f774eb112f85$var$cardContent.insertBefore($7b53f774eb112f85$var$mapCard, $7b53f774eb112f85$var$cardContent.children[1]);
    } else {
        $7b53f774eb112f85$var$cardRoot.appendChild($7b53f774eb112f85$var$mapCard);
        $7b53f774eb112f85$var$mapCard.style.position = 'absolute';
        $7b53f774eb112f85$var$mapCard.style.background = "linear-gradient(45deg, #ecf0f2 0%, #f7f8f9 100%)";
        $7b53f774eb112f85$var$mapCard.style.boxShadow = "-8px -8px 20px var(--shadow-light), 8px 8px 20px var(--shadow-dark), inset -5px -5px 15px var(--shadow-light), inset 5px 5px 10px #aeaec040";
        $7b53f774eb112f85$var$cardContent.style.width = "50%";
    }
}
function $7b53f774eb112f85$var$applyGeometry(W, H) {
    const { d: d, MAP_W: MAP_W, MAP_H: MAP_H, MAP_LEFT: MAP_LEFT } = $7b53f774eb112f85$var$buildPath(W, H, $7b53f774eb112f85$var$CARD);
    // L-card clip
    const lCard = document.getElementById('lCard');
    if (lCard) lCard.style.clipPath = `path("${d}")`;
    // Single SVG path — convex-bubble filter only
    const shadowPath = document.getElementById('insetLightPath');
    if (shadowPath) shadowPath.setAttribute('d', d);
    // SVG canvas sizing
    const svg = document.getElementById('insetSvg');
    if (svg) {
        svg.setAttribute('width', W);
        svg.setAttribute('height', H);
    }
    // Map card position + size
    const map = document.getElementById('mapCard');
    if (map) {
        map.style.left = `${MAP_LEFT}px`;
        map.style.width = `${MAP_W}px`;
        map.style.height = `${MAP_H}px`;
    }
}
const $7b53f774eb112f85$var$ro = new ResizeObserver((entries)=>{
    const { width: width, height: height } = entries[0].contentRect;
    const isMobile = width < 640; // stays in sync with getCardConfig's own threshold
    $7b53f774eb112f85$var$reparentMapCard(isMobile);
    $7b53f774eb112f85$var$applyGeometry(width, height); // always runs now
});
$7b53f774eb112f85$var$ro.observe($7b53f774eb112f85$var$cardRoot);


//# sourceMappingURL=web-build.c37abd80.js.map
